// UnAuthorized Routes
export const ROOT = "/";
export const LOGIN = "/login";
export const FORGOT_PASSWORD = "/forgotPassword"
export const RESET_PASSWORD = "/resetPassword"

// Dashboard
export const DASHBOARD = "/dashboard";
export const PROFILE = "/profile";
export const ADDSTUDENT = "/addStudent";
export const STUDENTS_LIST = "/studentsList";
export const FEE_SETUP = "/feeSetup"
export const STUDENTS_DETAILS = "/studentsList/details/:id";